<script setup lang="ts">
import type { MagentoBundleItem } from '~/types/magento'

const props = defineProps<{
  settings: MagentoBundleItem
}>()

const item = defineModel()

const single = ref<string>(props.settings.options[0]?.uid || '')

watch (single, (val: string) => {
  item.value = val ? [val] : []
})
</script>

<template>
  <div>
    <p><strong>{{ settings.title }}</strong></p>
    <template v-if="['checkbox', 'multi', 'radio'].includes(settings.type)">
      <div
        v-for="option in settings.options"
        :key="option.uid"
      >
        <label>
          <input
            v-if="['checkbox', 'multi'].includes(settings.type)"
            type="checkbox"
            :name="settings.uid"
            :value="option.uid"
            v-model="item"
          />
          <input
            v-else
            type="radio"
            :name="settings.uid"
            :value="option.uid"
            v-model="single"
          />
          {{ option.product.name }}
        </label>
      </div>
    </template>
    <template v-else>
      <select v-model="single">
        <option v-if="settings.required" disabled value="">
          Select an option
        </option>
        <option
          v-for="option in settings.options"
          :key="option.uid"
          :value="option.uid"
        >
          {{ option.product.name }}
        </option>
      </select>
    </template>
  </div>
</template>
